import moment from "moment";

export const initialBoard = (function () {
  return {
    itemIds: [],
    labelProps: [],
    view: "alltime", // last2weeks, last4weeks, alltime
    timeRange: [0, moment().add(1, "day").valueOf()],
    update: true,
  };
})();

export default function moodboardReducer(moodboard, action) {
  switch (action.type) {
    case "SET_MOODBOARD":
      return action.payload;

    case "UPDATE_MOODBOARD":
      return { ...moodboard, ...action.payload };

    case "CLEAR_LABELS":
      return {
        ...moodboard,
        labelProps: [],
      };

    case "TOGGLE_LIST":
      let itemIds = [...moodboard.itemIds];
      let labelProps = [...moodboard.labelProps];

      action.payload.ids.forEach((id) => {
        if (action.payload.type === "itemId") {
          // toggle itemIds
          const itemIdIndex = itemIds.indexOf(id);
          if (itemIdIndex > -1) {
            itemIds.splice(itemIdIndex, 1);
          } else {
            itemIds.push(id);
          }
          // TODO: tocheck
          /* if (
            action.payload.item.type === 2 &&
            id.includes("#") &&
            id.includes("-")
          ) {
            const buttonLabel = id.split("-")[1];
            if (!labels.includes(buttonLabel)) labels.push(buttonLabel);
          } */
        } else {
          // toggle labelProps
          const labelPropsIndex = labelProps.findIndex(
            (item) =>
              item.label === action.payload.item.labelProps.label &&
              item.type === action.payload.item.labelProps.type &&
              item.index === action.payload.item.labelProps.index
          );
          if (labelPropsIndex > -1) {
            labelProps.splice(labelPropsIndex, 1);
          } else {
            labelProps.push(action.payload.item.labelProps);
          }
        }
      });
      return {
        ...moodboard,
        itemIds,
        labelProps,
      };

    case "CHANGE_VIEW":
      let min = action.payload.timePoints[0];
      let max = action.payload.timePoints[action.payload.timePoints.length - 1];
      const view = action.payload.view;
      if (view === "last2weeks") {
        min = moment(max).subtract(2, "weeks").valueOf();
      }
      if (view === "last4weeks") {
        min = moment(max).subtract(4, "weeks").valueOf();
      }
      return { ...moodboard, ...{ timeRange: [min, max], view, update: true } };

    case "CHANGE_SLIDER":
      return {
        ...moodboard,
        ...{
          timeRange: [action.payload.timeRange[0], action.payload.timeRange[1]],
          view: "custom",
          update: action.payload.update,
        },
      };

    case "RESTORE_MOODBOARD":
      const timeRange = action.payload.update
        ? [action.payload.timeRange[0], moment().add(1, "day").valueOf()]
        : action.payload.timeRange;
      return { ...moodboard, ...action.payload, timeRange };

    default:
      return moodboard;
  }
}
